<template>
  <div>
    <router-link
      v-if="user"
      class="dropdown-item"
      :to="{ name: 'profile' }"
    >
      Profile
    </router-link>
    <router-link
      v-if="can('access-subscriptions')"
      class="dropdown-item"
      :to="{ name: 'subscriptions' }"
    >
      Subscriptions
    </router-link>
    <router-link
      v-if="can('access-health-data-scorecard')"
      class="dropdown-item"
      :to="{ name: 'health-data' }"
    >
      Health Assessment
    </router-link>
    <router-link
      v-if="can('access-health-data-scorecard')"
      class="dropdown-item"
      :to="{ name: 'scorecard' }"
    >
      Scorecard
    </router-link>
    <router-link
      v-if="can('access-individual-resources')"
      class="dropdown-item"
      :to="{ name: 'resources' }"
    >
      Resources
    </router-link>
    <router-link
      v-if="can('access-instructor-resources')"
      class="dropdown-item"
      :to="{name: 'instructor-resources'}"
    >
      Resources
    </router-link>
    <router-link
      v-if="can('access-food-service-resources')"
      class="dropdown-item"
      :to="{name: 'food-service-resources'}"
    >
      Resources
    </router-link>
    <router-link
      v-if="can('access-food-database')"
      class="dropdown-item"
      :to="{name: 'my-favorites'}"
    >
      Food Search
    </router-link>
    <router-link
      v-if="can('access-food-tracker')"
      class="dropdown-item"
      :to="{name: 'meal-entries'}"
    >
      Food Tracker
    </router-link>
    <router-link
      v-if="can('access-communications')"
      class="dropdown-item"
      :to="{name: 'communications'}"
    >
      Communications
    </router-link>
    <router-link
      v-if="can('access-share-portal')"
      class="dropdown-item"
      :to="{name: 'share-portal-profile'}"
    >
      Share Portal
    </router-link>
    <a
      v-if="user"
      class="dropdown-item"
      href="#"
      @click.prevent="logout()"
    >Log out</a>
    <router-link
      v-if="!user"
      class="dropdown-item"
      :to="{ name: 'signup' }"
    >
      Sign Up
    </router-link>
    <router-link
      v-if="!user"
      class="dropdown-item"
      :to="{ name: 'login' }"
    >
      Login
    </router-link>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters('user', [
      'user',
      'authenticated'
    ]),
  },
  methods: {
    logout () {
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push('/login');
        this.$store.dispatch('notifications/setSuccess', 'You have been logged out.');
      });
    },
  }
}
</script>
